// extracted by mini-css-extract-plugin
var _1 = "TableModalContent-modulecontainer__kO5Wk";
var _2 = "TableModalContent-modulenoData__m1BW9";
var _3 = "TableModalContent-moduletableModalContent__T8_GV";
var _4 = "TableModalContent-moduletableModalContentLoading__MYCbV";
var _5 = "TableModalContent-moduletableModalContentWrapper__Bb2rb Content-modulecontentWrapper__p1AMw";
export { _1 as "container", _2 as "noData", _3 as "tableModalContent", _4 as "tableModalContentLoading", _5 as "tableModalContentWrapper" }
